import api from './api';

export interface RoleProfileDTO {
  roleType: string;
  phoneNumber?: string;
  schoolCountry?: string;
  schoolCouncil?: string;
  schoolName?: string;
  schoolType?: string;
  courseInterests?: string;
  profession?: string;
  institutionName?: string;
  institutionCity?: string;
  institutionCountry?: string;
  institutionType?: string;
  subjectsTaught?: string;
  removedAt?: string;
  activatedAt?: string;
  updatedAt?: string;
}

export interface ActivatedRolesResponse {
  activatedRoles: RoleProfileDTO[];
  availableRoles: Array<{ roleType: string; status: string }>;
}

export interface RoleActivationRequest {
  phoneNumber?: string;
  schoolCountry?: string;
  schoolCouncil?: string;
  schoolName?: string;
  schoolType?: string;
  courseInterests?: string;
}

const userRoleService = {
  async getActivatedRoles(): Promise<ActivatedRolesResponse> {
    const response = await api.get('/api/users/roles');
    if (response.data?.success) return response.data.data as ActivatedRolesResponse;
    throw new Error(response.data?.message || 'Failed to fetch roles');
  },

  async getRoleProfile(roleType: string): Promise<RoleProfileDTO> {
    const response = await api.get(`/api/users/roles/${roleType}/profile`);
    if (response.data?.success) return response.data.data as RoleProfileDTO;
    throw new Error(response.data?.message || 'Failed to fetch role profile');
  },

  async updateRoleProfile(roleType: string, data: RoleActivationRequest): Promise<RoleProfileDTO> {
    const response = await api.put(`/api/users/roles/${roleType}/profile`, data);
    if (response.data?.success) return response.data.data as RoleProfileDTO;
    throw new Error(response.data?.message || 'Failed to update role profile');
  },

  async removeRole(roleType: string): Promise<void> {
    const response = await api.delete(`/api/users/roles/${roleType}`);
    if (!response.data?.success) {
      throw new Error(response.data?.message || 'Failed to remove role');
    }
  },
};

export default userRoleService;
